import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webhook-search',
  templateUrl: './webhook-search.component.html',
  styleUrls: ['./webhook-search.component.scss']
})
export class WebhookSearchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
